import React, { useEffect, useState } from 'react';
import { StatusMessageWrapper } from '../../pages/verification/Verification.styles';
import { useVerificationStore } from '../../context/VerificationContext';
import { DNVReportStatus } from '../../enums/dnvReportStatusEnum';
import { DNVReportType } from '../../enums/dnvReportTypeEnum';
import { getActiveReports } from '../../utils/verification/verificationUtils';

const StatsPanelComponent: React.FC = () => {
    const { populatedReportMetadataList, verificationFilter } = useVerificationStore();
    const [numVerifiedOdfjellReports, setNumVerifiedOdfjellReports] = useState<number | null>(null);
    const [numOdfjellReports, setNumOdfjellReports] = useState<number>(null);

    useEffect(() => {
        if (populatedReportMetadataList && verificationFilter) {
            let _odfjellReportMetadataList = getActiveReports(populatedReportMetadataList).filter((r) =>
                verificationFilter.selectedYears?.some(
                    (v) =>
                        Number(v.value) === new Date(r.voyageDateTimeUtcFrom).getFullYear() ||
                        Number(v.value) === new Date(r.voyageDateTimeUtcTo).getFullYear()
                )
            );

            _odfjellReportMetadataList = _odfjellReportMetadataList.filter((r) =>
                verificationFilter.selectedManagers?.some((v) => v.value === r.manager.toString())
            );

            _odfjellReportMetadataList = _odfjellReportMetadataList.filter((r) => r.reportType === DNVReportType.OVDLA);

            const _verifiedOdfjellReportMetadataList = _odfjellReportMetadataList.filter((r) => r.status === DNVReportStatus.VerifiedByDNV);

            if (_verifiedOdfjellReportMetadataList) {
                setNumVerifiedOdfjellReports(_verifiedOdfjellReportMetadataList.length);
            }

            if (_odfjellReportMetadataList) {
                setNumOdfjellReports(_odfjellReportMetadataList.length);
            }
        }
    }, [populatedReportMetadataList, verificationFilter]);

    const getPctVerifiedText = () => {
        return Number((numVerifiedOdfjellReports / numOdfjellReports) * 100).toFixed(0) + '% verified';
    };

    return (
        <>
            {!!numVerifiedOdfjellReports && numOdfjellReports && (
                <StatusMessageWrapper>
                    <h3>{getPctVerifiedText()}</h3>
                    <h5>for selected year and manager</h5>
                </StatusMessageWrapper>
            )}
        </>
    );
};
export default StatsPanelComponent;
